// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.paixu {\r\n  float: none;\r\n  display: -webkit-box !important;\r\n  display: -ms-flexbox !important;\r\n  display: flex !important;\r\n  margin-left: 50px;\r\n  margin-bottom: 10px;\r\n  margin-top: -30px;\r\n  color: #ffffff;\n}\r\n", ""]);
// Exports
module.exports = exports;
